import React from 'react';
import Typography from '@material-ui/core/Typography';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Divider from '@material-ui/core/Divider';
import Button from '@material-ui/core/Button';
import SwipeableViews from 'react-swipeable-views';
import clsx from 'clsx';
import { withStyles } from "@material-ui/core/styles";
import { assoc } from 'ramda';

const confirmDeletion = assoc('confirmDeletion');

export const TeamMemberCardMenu = withStyles(theme => ({
  dialog: {
    width: 340,
  },
  dialogContent: {
    height: 98,
    padding: 0,

    '&:first-child': {
      paddingTop: 0,
    }
  },
  dialogTitle: {
    // width: 328,
    padding: 16,
    textAlign: 'center',
  },
  title: {
    marginBottom: 0,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  actionList: {
    paddingTop: 0,
    paddingBottom: 0,
  },
  listItem: {
    textAlign: 'center',
    cursor: 'pointer',
  },
  warn: {
    color: theme.palette.warn.main,
  },
  dialogContentContainer: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    padding: '0 16px',
  },
  textContainer: {
    flexGrow: 1,
  },
  actionContainer: {
    height: 50,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
  },
  confirmDeletion: {
    color: theme.palette.warn.main,
  },
}))(({
  classes,
  member,
  open = false,
  disabled = false,
  onClose = () => { },
  onRemoveMember = () => {},
}) => {
  const [state, setState] = React.useState({
    confirmDeletion: false,
  });

  const handleConfirmDeletion = () => setState(confirmDeletion(true));
  const handleCancelDeletion = () => setState(confirmDeletion(false));

  return (
    <Dialog classes={{ paper: classes.dialog }} onClose={onClose} open={open}>
      <DialogTitle className={classes.dialogTitle} disableTypography>
        <Typography variant='h3' component='h3' className={classes.title}>
          {member.account.firstName} {member.account.lastName}
        </Typography>
      </DialogTitle>

      <SwipeableViews disabled={true} index={state.confirmDeletion ? 1 : 0}>
        <DialogContent className={classes.dialogContent}>
          <List className={classes.actionList}>
            <Divider />
            <ListItem>
              <ListItemText
                className={clsx(classes.listItem, classes.warn)}
                primary='Remove Member'
                onClick={(handleConfirmDeletion)}
              />
            </ListItem>
            <Divider />
            <ListItem>
              <ListItemText
                className={classes.listItem}
                primary='Cancel'
                onClick={onClose}
              />
            </ListItem>
          </List>
        </DialogContent>
        <DialogContent className={classes.dialogContent}>
          {
            state.confirmDeletion
              ? <div className={classes.dialogContentContainer}>
                <Typography className={classes.textContainer}>
                  Are you sure you want to remove this member from the team?
                </Typography>
                <div className={classes.actionContainer}>
                  <Button onClick={handleCancelDeletion}>
                    Back
                  </Button>
                  <Button
                    onClick={() => onRemoveMember(member)}
                    className={classes.confirmDeletion}
                    disabled={disabled}
                  >
                    Delete
                  </Button>
                </div>
              </div>
              : null
          }
        </DialogContent>
      </SwipeableViews>
    </Dialog>
  );
});